import type { Condition } from '../types/conditions';

/**
 * Recursively collects `field` paths referenced in a condition tree.
 * Does not include optionProp/meta/custom paths — those are not form-value subscriptions.
 */
export function extractConditionFieldPaths(condition: Condition | undefined): string[] {
  if (!condition) return [];
  const paths = new Set<string>();
  walkCondition(condition, paths);
  return Array.from(paths);
}

function walkCondition(cond: Condition, paths: Set<string>): void {
  if (typeof cond !== 'object' || cond === null) return;

  if ('field' in cond && typeof cond.field === 'string') {
    paths.add(cond.field);
  }

  if ('allOf' in cond && Array.isArray(cond.allOf)) {
    cond.allOf.forEach((child) => walkCondition(child, paths));
  }

  if ('anyOf' in cond && Array.isArray(cond.anyOf)) {
    cond.anyOf.forEach((child) => walkCondition(child, paths));
  }

  if ('not' in cond && cond.not) {
    walkCondition(cond.not, paths);
  }
}
